module.exports = __webpack_public_path__ + "static/assets/101832d039d41a1b96135b8ee52264ae.png";